import { Debtor } from 'utils/formDependencies/statics/enums/Debtor'
import { Data } from 'interfaces/ApolloResponse.interface'
import isEmployedOrHasMinijob from 'utils/formDependencies/conditions/isEmployedOrHasMinijob'
export const showEmploymentPage = (data: Data) =>
  isEmployedOrHasMinijob(Debtor.PRIMARY)(data) ||
  (data.debtors.count === 2 && isEmployedOrHasMinijob(Debtor.SECONDARY)(data))

export const isAbCustomer = (rootStore: {
  urlParams: { utm_campaign?: string }
}) => rootStore.urlParams.utm_campaign?.includes('_ab_') ?? false
